import { useQuery } from '@apollo/client'
import { useTranslate } from '@ur-solutions/react-hooks'
import { CenteredLoader } from '@/components_deprecated'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import styled from 'styled-components'
import type { IdVariable } from '@/types/graphql'
import {
  useBreadcrumbs,
  useOnErrorAuto,
  useParam,
  useUser,
} from '@/utils/hooks'
import { FormForm } from '../components'
import { FORM_TEMPLATE_FOR_FORM_SUBMIT_QUERY } from '../queries'
import type { FormTemplateForFormSubmitQuery } from '../types.graphql'
import { PreviousAnswers } from './PreviousAnswers'

const Wrapper = styled.div`
  ${props => props.theme.layout.default};
  display: flex;
  flex-direction: column;
  gap: 2rem;

  & > .form {
    max-width: 800px;

    .form-fields {
      max-width: 800px;
    }
  }
`

interface SubmitFormProps {}

export const SubmitForm: React.FC<SubmitFormProps> = () => {
  const translations = useTranslate({
    loading: 'common.loading-ellipsis',
  })

  const formId = useParam('formId')

  const navigate = useNavigate()

  const me = useUser()
  const { setOverride } = useBreadcrumbs()
  const onErrorAuto = useOnErrorAuto()

  const { data, loading } = useQuery<
    FormTemplateForFormSubmitQuery,
    IdVariable & { userId: string }
  >(FORM_TEMPLATE_FOR_FORM_SUBMIT_QUERY, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: { id: formId, userId: me.id },
    onCompleted(data) {
      if (!data) return
      setOverride(data.formTemplate.id, data.formTemplate.name)
    },
    onError: onErrorAuto(),
  })

  useEffect(() => {
    if (data) return
    setOverride(formId, translations.loading)
  }, [data, formId, setOverride, translations.loading])

  function handleAfterSubmit(success: boolean) {
    if (success) void navigate('/formcreator')
  }

  if (!data || loading) return <CenteredLoader />

  return (
    <Wrapper>
      <FormForm
        className="form"
        form={data.formTemplate}
        onAfterSubmit={handleAfterSubmit}
      />
      <PreviousAnswers
        filledOutForms={data.formTemplate.filledOutForms}
        form={data.formTemplate}
      />
    </Wrapper>
  )
}
